import {
  AfterContentInit,
  AfterViewInit,
  Component,
} from '@angular/core';
import {
  UntypedFormBuilder,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NGXLogger } from 'ngx-logger';
import {
  BookingService,
  CountryService,
  ExamService,
  FormUtilsService,
  GenderService,
  NotificationService,
  ProfileService,
  UserService,
} from 'src/app/services';
import { RadioOption } from 'src/app/types';
import { Step1ProfileCheckFormComponent as DefaultStep1ProfileCheckFormComponent } from '../../default';

@Component({
  selector: 'app-step1-profile-check-form-sdv',
  templateUrl:
    './step1-profile-check-form-sdv.component.html',
})
export class Step1ProfileCheckFormSdvComponent
  extends DefaultStep1ProfileCheckFormComponent
  implements AfterContentInit, AfterViewInit
{
  parentalAddressesOptions: RadioOption[] = [
    {
      label:
        'userInfo.parental-addresses.radio-btn.options.yes',
      value: true,
    },
    {
      label:
        'userInfo.parental-addresses.radio-btn.options.no',
      value: false,
    },
  ];

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected countryService: CountryService,
    protected examService: ExamService,
    protected formBuilder: UntypedFormBuilder,
    protected formUtils: FormUtilsService,
    protected genderService: GenderService,
    protected logger: NGXLogger,
    protected modalService: BsModalService,
    protected notificationService: NotificationService,
    protected profileService: ProfileService,
    protected userService: UserService,
    protected router: Router,
    protected bookingService: BookingService
  ) {
    super(
      activatedRoute,
      countryService,
      examService,
      formBuilder,
      formUtils,
      genderService,
      logger,
      modalService,
      notificationService,
      profileService,
      userService
    );
  }

  ngAfterContentInit() {
    super.ngAfterViewInit();
  }

  ngAfterViewInit(): void {
    this.parentalAddressesRadioControl.valueChanges.subscribe(
      (isParentalAddresses) => {
        if (
          isParentalAddresses &&
          this.item.parentalAddresses.length === 0
        ) {
          this.addParentalAddress();
        } else if (!isParentalAddresses) {
          this.removeParentalAddresses();
        }
      }
    );
  }

  private addParentalAddress(): void {
    const parentAddress = this.formBuilder.group({
      street: ['', Validators.required],
      streetNumber: ['', Validators.required],
      additionalAddressInfo: [''],
      zip: ['', Validators.required],
      city: ['', Validators.required],
      state: [''],
      country: ['', Validators.required],
    });

    this.parentalAddressesFormArray.push(parentAddress);
  }

  private removeParentalAddresses(): void {
    this.parentalAddressesFormArray.clear();
    this.userService.formState.item.parentalAddresses = [];
  }
}
